import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';

import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';

import { IcalOnboardingBannerComponent } from './ical-onboarding-banner/ical-onboarding-banner.component';
import { IcalSubscribeModalComponent } from './ical-subscribe-modal/ical-subscribe-modal.component';

@NgModule({
  declarations: [IcalOnboardingBannerComponent, IcalSubscribeModalComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ClipboardModule,
    MatIconModule,
    MatDialogModule,
    MatSnackBarModule,
    MatTabsModule,
  ],
  exports: [IcalOnboardingBannerComponent],
})
export class AlertsOnboardingModule {}
